import React, { useEffect, useState } from "react";
import {
  AddToCompare,
  RemoveFromCompare,
  setCarPopup,
  setLayer,
  toggleChooseCar,
} from "redux/actions/globalAction";
import { connect } from "react-redux";
import TyreComparisonModal from "./tyresListing/TyreComparisonModal";
import ChooseCar from "components/Header/ChooseCar";
import { isMobile } from "react-device-detect";
import {
  Row,
  Col,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Popover,
  Button,
  Form,
  Nav,
  Modal,
  Spinner,
} from "react-bootstrap";
import { BsInfoCircle } from "react-icons/bs";
import Tyre from "./Tyre";
import {
  batteryQuotation,
  obWorkshop,
  tyreQuotation,
  workshopPurchase,
} from "lib/config";
import {
  setCartJobItems,
  setCartJourney,
  setCartProducts,
  setCartStage,
  setCartTypeParameter,
  setCartWorkshop,
  setShowMobileIstand,
} from "redux/actions/cartAction";
import {
  getNewTyresVariants,
  getNewTyresVariantsByModel,
  getWorkshopFilterMapTyre,
} from "redux/actions/apiActions";
import Offers from "components/checkout/Offers";
import { gtm_ecommerce_remove_from_cart } from "lib/GA4_tag";
import { saveCart, saveCartJobs } from "lib/cart";
import { delBasePath } from "next/dist/shared/lib/router/router";
import { gtmChooseService } from "lib/google-tag-manager";
import ReadMoreReact from "read-more-react/dist/components/ReadMoreReact";
import { useRouter } from "next/router";
import { workshopSelection } from "actions/Cart";
import ChooseCarMobile from "components/common/ChooseCarMobile";
import Select from "react-select";
import { MdInfoOutline } from "react-icons/md";
const NewTyres = ({
  cart,
  AddToCompare,
  RemoveFromCompare,
  toggleChooseCar,
  globalData,
  getModel,
  getCarBrandModal,
  apiData,
  setCartJourney,
  getNewTyresVariantsByModel,
  setLayer,
  setShowMobileIstand,
  setCartProducts,
  setCartJobItems,
  getWorkshopFilterMapTyre,
  setCartStage,
  setCartWorkshop,
  setCartTypeParameter,
  setCarPopup,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [carData, setCarData] = useState(null);
  const [searchSelect, setSearchSelect] = useState(1);
  const [carPopupMobile, setCarPopupMobile] = useState(false);
  // const [showCarPopUp, setShowCarPopUp] = useState(false);
  const [carHide, setCarHide] = useState(false);
  const [tyreProduct, setTyreProduct] = useState([]);
  const [tyre, setTyre] = useState([]);
  const [tyreCompare, setTyreCompare] = useState([]);
  const [selectedTyreProduct, setSelectedTyreProduct] = useState([]);
  const [tyreSize, setTyreSize] = useState(null);
  const [showQuoteSelect, setShowQuoteSelect] = useState(false);
  const [changeOfferModalShow, setChangeOfferModalShow] = useState(false);
  const [CurrentOffers, setCurrentOffers] = useState([]);
  const [showDescription, setShowDescription] = useState(null);
  const [discountValue, setDiscountValue] = useState(0);
  const [defaultProduct, setDefaultProduct] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showEmpty, setShowEmpty] = useState(false);
  const [tyreBrandOptions, setTyreBrandOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showQuoteSelectTyre, setShowQuoteSelectTyre] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    value: "1",
    label: "1",
  });
  const [hidePoint, setHidePoint] = useState(0);
  const [scroll, setScroll] = useState(0);

  const router = useRouter();
  const handleClose = () => {
    setShowModal(false);
  };
  const handleComparison = () => {
    setShowModal(!showModal);
  };
  const handleCompare = (e, product) => {
    if (e.target.checked == true) {
      AddToCompare(product);
      setTyreCompare([...tyreCompare, product]);
    } else {
      RemoveFromCompare(product);
      setTyreCompare(tyreCompare.filter((item) => item !== product));
    }
  };
  let { products, jobItems, workshop } = cart;
  const options = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
  ];

  const handleChange = (selectedOption, product) => {
    const selectedValue = parseFloat(selectedOption.value);
    const newCost = selectedValue * product.OriginalCost;
    setSelectedValue(selectedOption);
    setTyreProduct((prevProducts) => {
      return prevProducts.map((prevProduct) => {
        if (prevProduct.Id === product.Id) {
          return { ...prevProduct, Cost: newCost };
        } else {
          return prevProduct;
        }
      });
    });
  };
  const handleAddToCompair = (e, product) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setTyreProduct((prevProducts) => {
        return prevProducts.map((prevProduct) => {
          if (prevProduct.Id === product.Id) {
            return { ...prevProduct, AtHomeCost: 100 };
          } else {
            return prevProduct;
          }
        });
      });
    } else if (!isChecked) {
      setTyreProduct((prevProducts) => {
        return prevProducts.map((prevProduct) => {
          if (prevProduct.Id === product.Id) {
            return { ...prevProduct, AtHomeCost: null };
          } else {
            return prevProduct;
          }
        });
      });
    }
  };

  useEffect(() => {
    const tyreProducts = JSON.parse(
      localStorage.getItem("tyreProduct") || JSON.stringify("")
    );

    if (tyreProducts) {
      setCartProducts(tyreProducts);
    }
  }, []);

  useEffect(() => {
    const CarData = JSON.parse(
      localStorage.getItem("car_data") || JSON.stringify("")
    );

    setCarData(CarData);
    if (CarData) {
      getNewTyresVariantsByModel(CarData?.modelId);
      setTyreSize(null);
    }
    console.log(CarData);
  }, [globalData?.carData]);

  useEffect(() => {
    if (apiData?.tyreVariants) {
      const uniqueBrandNames = new Set();

      apiData.tyreVariants.forEach((product) => {
        uniqueBrandNames.add(product.Name);
      });

      const brandOptions = Array.from(uniqueBrandNames).map((brandName) => ({
        value: brandName,
        label: brandName,
      }));

      setTyreBrandOptions(brandOptions);

      setTyreProduct(apiData.tyreVariants);
      setTyre(apiData.tyreVariants);
      setDefaultProduct(apiData.tyreVariants[0]);
    }
  }, [apiData?.tyreVariants]);

  useEffect(() => {
    if (globalData?.newCarTyerSize) {
      setTyreSize(globalData?.newCarTyerSize);
    }
  }, [globalData?.newCarTyerSize]);
  const handleshowOffers = (offer) => {
    setChangeOfferModalShow(true);
    setCurrentOffers(offer);
  };
  const addOffers = (offers, show = false) => {
    const filterCategory = globalData.currentCategory?.filter(
      (item) => item.ID == selectedTyreProduct.JourneyCategoryId
    );
    if (offers && !show) {
      const event = {
        promotion_id: offers.PromotionId,
        promotion_name: offers.PromotionName,
        items: [
          {
            item_id: selectedTyreProduct.Id,
            item_name: selectedTyreProduct.Name,
            coupon: offers.PromotionCode || offers.PromotionId,
            discount: selectedTyreProduct.DiscountedCost || 0,
            item_category: filterCategory[0]?.Name,
            item_list_id: filterCategory[0]?.ID,
            item_list_name: filterCategory[0]?.Name,
            price: selectedTyreProduct.Cost,
            quantity: 1,
          },
        ],
      };

      gtm_ecommerce_select_promotion(event);
    }
    const immutableOffer = { ...offers };
    if (cart.workshop) {
      const offer = cart.workshop.Offers
        ? cart.workshop.Offers.find((e) => {
            return e?.PromotionId === immutableOffer.PromotionId;
          })
        : null;
      if (offer) immutableOffer.isOfferWorkshopSelected = true;
    }
    AppliedCartOffers(immutableOffer);
    if (!show) {
      setChangeOfferModalShow(false);
    }
  };
  const productNavigate = () => {
    let immutableUrl = "/";
    router.query.slug?.map((item, index) => {
      immutableUrl += index == 1 ? "tyre" : item;
      immutableUrl += "/";
      return item;
    });
    router.push(
      {
        pathname: `/services/[...slug]`,
      },
      "/services" + immutableUrl,
      { shallow: true }
    );
  };
  const handleUnselect = () => {
    setCartStage(null);
    if (!sessionStorage.getItem("isWorkshopCollection")) setCartWorkshop(null);
    localStorage.removeItem("tyreProduct");
  };
  const addToCart = async (item) => {
    setLayer(true);
    setIsSubmitting(true);
    if (isMobile) {
      setShowMobileIstand(true);
    }

    const result = products.filter((res, index) => res.Id == item.Id);
    if (result.length == 0) {
      try {
        setCartProducts([...products, item]);
        localStorage.setItem(
          "tyreProduct",
          JSON.stringify([...products, item])
        );
        setCartJobItems([...jobItems, item]);

        saveCartJobs(cart, apiData, globalData, [...jobItems, item]);
        setIsSubmitting(false);
      } catch (e) {
        console.log("Error", e);
        setIsSubmitting(false);
      }
    } else {
      toast.dismiss();
      toast.error("Already Added!");
      setIsSubmitting(false);
    }
  };

  const removeFromCart = (item) => {
    setIsSubmitting(true);
    const result = products.filter((res, index) => res.Id != item.Id);
    const resultJobItems = jobItems.filter(
      (res) => res.JourneyVariantId != item.Id
    );

    if (result.length == 0) {
      setShowEmpty(true);
      setCartProducts(result);
      setCartStage(null);
      localStorage.removeItem("tyreProduct");
      setCartWorkshop(null);
      if (localStorage.getItem("obWorkshop")) {
        sessionStorage.removeItem("isWorkshopCollection");
        localStorage.removeItem("obWorkshop");
      }
    } else {
      localStorage.setItem("tyreProduct", JSON.stringify([...result]));
      setCartProducts(result);
      setCartJobItems(resultJobItems);
      saveCartJobs(cart, apiData, globalData, resultJobItems);
    }
    setIsSubmitting(false);
  };
  const removeFromCartEvent = (item) => {
    let offer;
    const isOfferApplied = cart.appliedCartOffers?.variantId == item?.Id;

    if (isOfferApplied) {
      offer = item.Offers.filter(
        (item) => item.PromotionId == cart.appliedCartOffers?.PromotionId
      );
    }
    const filterCategory = globalData.currentCategory?.filter(
      (item) => item.ID == item.JourneyCategoryId
    );

    const event = {
      currency: "AED",
      value: selectedTyreProduct.Cost,
      items: [
        {
          item_id: item.Id,
          item_name: item.Name,
          coupon: offer?.length
            ? offer[0]?.PromotionCode || offer[0].PromotionId
            : null,
          discount: item.DiscountedCost || 0,
          item_category: filterCategory[0].Name,
          item_list_id: filterCategory[0].ID,
          item_list_name: filterCategory[0].Name,
          price: item.Cost,
          quantity: 1,
        },
      ],
    };

    gtm_ecommerce_remove_from_cart(event);
  };

  const popoverHoverFocus = (
    <Popover
      id="popover-trigger-hover-focus"
      title="FULLY FITTED PRICE PER TYRE"
      style={{ padding: "20px 22px", width: "380px" }}
      className="light-blue-new"
    >
      <h6 style={{ fontWeight: "bold" }}>FULLY FITTED PRICE PER TYRE</h6>
      <p>
        No additional fees for tyre fitting on your visit day - following costs
        included:
      </p>
      <ul
        style={{ listStyleType: "disc", paddingLeft: "20px", fontSize: "13px" }}
      >
        <li>VAT</li>
        <li>Fitting (Bead lock wheel etc. excluded)</li>
        <li>Balancing</li>
        <li>New rubber valve (standard valve only)</li>
        <li>Delivery to installer</li>
        <li>Disposal of old tyres</li>
        <li>
          On purchase of 4 tyres, 1 FREE scheduled instance of tyre rotation
          every 20,000kms per year
        </li>
      </ul>
    </Popover>
  );

  useEffect(() => {
    if (
      cart?.appliedCartOffers &&
      ((cart?.appliedCartOffers.PromotionType != "WorkshopProductPromotion" &&
        cart?.appliedCartOffers.PromotionType != "WorkshopPromotion") ||
        ((cart?.appliedCartOffers.PromotionType == "WorkshopProductPromotion" ||
          cart?.appliedCartOffers.PromotionType == "WorkshopPromotion") &&
          cart?.appliedCartOffers?.isOfferWorkshopSelected))
    ) {
      const isOfferAvailable =
        item.Offers && item?.Offers.length
          ? item.Offers.filter(
              (offer) => offer.PromotionId == cart.appliedCartOffers.PromotionId
            ).length
          : false;
      if (!isOfferAvailable) {
        setDiscountValue(0);
        return;
      }
      const cost = parseFloat(
        defaultProduct?.Cost ? defaultProduct.Cost : item?.OrginalCost
      );
      const discountPercentage = cart?.appliedCartOffers?.PromotionPercentValue
        ? parseFloat(cart?.appliedCartOffers?.PromotionPercentValue)
        : 0;
      const d_amount = (cost * discountPercentage) / 100;
      const flatvalue = parseFloat(
        cart?.appliedCartOffers?.PromotionFlatValue
          ? cart?.appliedCartOffers?.PromotionFlatValue
          : 0
      );
      const remainingValue = cost - d_amount - flatvalue;
      setDiscountValue(parseFloat(remainingValue).toFixed(2));
    } else {
      setDiscountValue(0);
    }
  }, [cart?.appliedCartOffers, selectedTyreProduct, defaultProduct]);

  // useEffect(() => {
  //   if (tyreProduct.length > 0 && tyreBrandOptions.length < 0) {
  //     const brandOptions = tyreProduct.map((product) => {
  //       return { value: product.Name, label: product.Name }; // Assuming 'Name' property holds the brand name
  //     });
  //     setTyreBrandOptions(brandOptions);
  //   }
  // }, [tyreProduct]);

  const selectTyre = (newValue) => {
    if (newValue && tyre.length) {
      setSelectedOption(newValue);
      console.log(newValue);

      const selectedTyre = tyre.filter((data) => data.Name == newValue.label);
      setTyreProduct(selectedTyre);
    } else {
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      // borderColor: '#0000',
      marginTop: "1px",
      minHeight: "25x",
      fontSize: "10px",
      height: "28px",
      width: "140px",
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "25px",
      padding: "0 6px",
      width: "140px",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "25px",
    }),
  };

  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: "white" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "red" : "#fff",
        color: "#000",
        cursor: isDisabled ? "not-allowed" : "default",
        textAlign: "center",
      };
    },
    menuList: (styles) => ({
      ...styles,
      height: "130px",
    }),
  };
  const handleWorkshopSelection = async (item) => {
    const brandId =
      item && item?.Products && item.Products?.length ? brandId : null;
    setIsSubmitting(true);
    gtmChooseService(item?.Name);

    setLayer(true);

    if (item?.AtHomeCost) {
      let jobs = [];

      // setShow(false);

      jobs.push(item);
      setCartJobItems([...jobs]);
      setCartWorkshop(apiData.defaultWorkshop);
      setCartStage(2);

      sessionStorage.setItem("isWorkshopCollection", true);
      localStorage.setItem("obWorkshop", true);
      localStorage.removeItem("isQuoterequest");
      setShowQuoteSelectTyre(false);
    } else {
      setShowQuoteSelect(false);
      localStorage.removeItem("isQuoterequest");
      setCartJourney(workshopPurchase);
      if (!localStorage.getItem("obWorkshop") || !cart?.stage) {
        setCartStage(1);
      }
    }
    if (isMobile) {
      setShowMobileIstand(true);
    }
    // setTypeOne(0);

    setCartProducts([item]);
    localStorage.setItem("tyreProduct", JSON.stringify([item]));
    setSelectedTyreProduct((data) => [...data, item]);
    localStorage.setItem("product-id", JSON.stringify(item.Id));
    localStorage.setItem("product-amount", JSON.stringify(item.Cost));
    localStorage.setItem("brand-id", brandId);

    getWorkshopFilterMapTyre(
      item.Id,
      globalData.locationData?.lat,
      globalData.locationData?.lng
    );

    setIsSubmitting(false);
    productNavigate();
  };
  useEffect(() => {
    let footer = document.getElementsByTagName("footer")[0];
    setHidePoint(
      window.document.body.scrollHeight -
        window.innerHeight * 1 -
        2.5 * footer.scrollHeight
    );

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [
    typeof window !== "undefined" ? window.document.body.scrollHeight : null,
  ]);
  const handleScroll = () => {
    setScroll(window.scrollY);
  };
  return (
    <>
      <TyreComparisonModal
        handleWorkshopSelection={handleWorkshopSelection}
        showModal={showModal}
        handleClose={handleClose}
        tyreCompare={tyreCompare}
      />
      {!carData && !tyreSize ? (
        <>
          <div
            className={`row ${
              isMobile ? "mt-0 ml-0" : "mt-4"
            }d-flex p-3 justify-content-center pl-list-header pl-list-header-tyre border-none flex-column align-items-center mb-4`}
          >
            <div className="tyre-banner">
              <img
                className="tire-banner-imgae"
                src="/assets/products/man-choosing-car-checking-tires-2.webp"
              />
            </div>
            <div
              className={`row ${
                isMobile ? "w-100" : "w-75"
              } justify-content-between mt-4 align-items-center`}
            >
              <div
                style={{ cursor: "pointer", padding: " 6px 25px" }}
                className={`font-weight-bold  req-an-btn-tyre req-an-btn ${
                  !searchSelect ? " req-an-btn" : "req-an-btn"
                }`}
                onClick={() => {
                  setSearchSelect(0);
                  // localStorage.setItem("isQuoterequest", true);
                  setCartJourney(tyreQuotation);
                  if (isMobile) {
                    setShowMobileIstand(true);
                  }
                  setLayer(true);
                }}
              >
                SEARCH BY SIZE
              </div>{" "}
              <div
                className=""
                onClick={() => {
                  setSearchSelect(1);
                  setCartJourney(workshopPurchase);
                }}
              >
                {" "}
                <div style={{ cursor: "pointer" }}>
                  {!isMobile ? (
                    <ChooseCar
                      // CHoose Car to View Price\
                      globalData={globalData}
                      style={
                        searchSelect
                          ? " req-an-btn req-an-btn-tyre font-weight-bold mr-0"
                          : " req-an-btn font-weight-bold mr-0 "
                      }
                      textTrue={true}
                      apiData={apiData}
                      getModel={getModel}
                      getCarBrandModal={getCarBrandModal}
                      text="SEARCH BY CAR "
                      // mobileCartView
                      showMobileBtn={false}
                    />
                  ) : (
                    <div
                      className={`${
                        searchSelect
                          ? "req-an-btn req-an-btn-tyre font-weight-bold mr-0"
                          : "req-an-btn-tyre font-weight-bold req-an-btn mr-0"
                      }`}
                      onClick={() => {
                        setShowCarPopUp(true);
                      }}
                    >
                      SEARCH BY CAR{" "}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="mt-4 ">
            {tyreProduct.length > 0 && (
              <button
                onClick={() => handleComparison()}
                style={{
                  visibility: tyreCompare.length < 2 ? "hidden" : "visible",
                }}
                className={
                  tyreCompare.length < 2
                    ? "view-comparison-btn-disabled"
                    : "view-comparison-btn"
                }
                disabled={tyreCompare.length < 2}
              >
                View Comparison ({tyreCompare.length})
              </button>
            )}
            <div
              className="container-fluid tyre-fixed-header px-0"
              style={
                {
                  // visibility: hidePoint < scroll ? "hidden" : "visible",
                }
              }
            >
              <div
                className="col-lg-7 col-md-7 col-sm-12"
                style={{ padding: 0, paddingRight: "8px" }}
              >
                <div className="pl-list-outer pl-list-header mb-0">
                  <div className="pl-list-header-lf">
                    <h2>Buy New Tyres</h2>
                    <p>
                      {tyreProduct.length} tyre(s) found for{" "}
                      {!tyreSize
                        ? `${carData?.brand} - ${carData?.modal}`
                        : `size : ${tyreSize?.width}/${tyreSize?.height}/R${tyreSize?.rim}`}
                      .{" "}
                    </p>
                  </div>
                  <div className="pl-list-header-rt">
                    <div
                      className="pl-list-header-rt"
                      style={{ display: "flex", paddingTop: "6px" }}
                    >
                      <button
                        className="btn-tyres-orng text-white"
                        style={{
                          minWidth: "130px",
                          padding: "9px",
                          fontSize: "12px",
                        }}
                        onClick={() => {
                          if (isMobile) {
                            setCarPopupMobile("brand");
                          } else setCarPopup("brand");
                        }}
                      >
                        {carData ? "Change Car" : "Choose By Car"}{" "}
                      </button>
                      <button
                        className="ml-1 btn-tyres-orng text-white"
                        style={{
                          minWidth: "130px",
                          padding: "9px",
                          fontSize: "12px",
                        }}
                        onClick={() => {
                          //  localStorage.setItem("isQuoterequest", true);
                          setCartJourney(tyreQuotation);
                          //  setCartJourney(workshopPurchase);
                          let tyreItem = cart.tyreQuotation;
                          tyreItem.isProceed = false;
                          tyreItem.width = null;
                          tyreItem.height = null;
                          tyreItem.rim = null;
                          tyreItem.data = null;
                          setCartTypeParameter(tyreItem);
                          if (isMobile) {
                            setShowMobileIstand(true);
                          }
                          setLayer(true);
                        }}
                      >
                        Change Tyre Size
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-5" />
            </div>
            <div style={{ marginTop: "82px" }}>
              {tyreProduct.length > 0 ? (
                tyreProduct.map((product, index) => {
                  return (
                    <div className="pl-list-outer">
                      <div
                        className="listing-container-pl srolled-list-pl border-bottom-0"
                        key={index}
                      >
                        <div className="row">
                          <div className="col-md-12">
                            <div className="product-section-pl-header">
                              <div className="product-section-pl-hd-flex align-items-center">
                                <div className="d-flex align-items-center">
                                  <h3>{`${product.Name} - `}</h3>
                                  <h3>{product?.Tyres[0]?.Code}</h3>
                                </div>
                                <div className="lbl-flex">
                                  <label
                                    style={
                                      product.IsRecommended || product.LableText
                                        ? {}
                                        : { display: "none" }
                                    }
                                  >
                                    {product?.IsRecommended ? (
                                      <span className="rec-lab">
                                        Recommended{" "}
                                        <i className="fa-regular fa-thumbs-up" />
                                      </span>
                                    ) : (
                                      <></>
                                    )}

                                    {product?.LableText ? (
                                      <span
                                        className="free-lab"
                                        style={{
                                          background:
                                            "linear-gradient(0deg, rgba(247,146,34,1) 0%, rgba(255,50,1,1) 100%)",
                                          color: "white",
                                        }}
                                      >
                                        {product?.LableText}
                                      </span>
                                    ) : null}
                                  </label>
                                </div>

                                {product?.Tyres[0]?.YoM ? (
                                  <div className="tyre-manufacturing-year">
                                    <p style={{ color: "#ff3201" }}>
                                      {product?.Tyres[0]?.YoM}
                                    </p>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                              {/* <div className="mnf-yrs">Year of Manufacture 2019</div> */}
                            </div>
                          </div>

                          <div className="pl-fl-box">
                            <div className="pl-fl-img">
                              <div
                                className="position-relative-pr-tyre"
                                style={{ padding: 15 }}
                              >
                                {product.TimeDuration && (
                                  <label>
                                    <i className="fa-clock-cs">
                                      <img src="/assets/products/clock.svg" />
                                    </i>
                                    {product.TimeDuration + " "}
                                  </label>
                                )}
                                {/* <img
                                  className="tyreLogo"
                                  src="/assets/products/Goodyear-Logo.webp"
                                /> */}
                                <img
                                  className="product-image-container-pl-tyre"
                                  src={
                                    product.ImgUrl ||
                                    "/assets/products/tire.webp"
                                  }
                                />
                                {/* <level className="tyreMYear" > japan (2019) </level> */}
                                {/* <img
                                  width={50}
                                  height={20}
                                  className="tyreWarrenty"
                                  src="/assets/header/warrenty.webp"
                                  alt="Image"
                                /> */}
                              </div>
                            </div>

                            <div className="pl-fl-ft-sec">
                              <div className="pl-fl-lst min-pl-height">
                                <Row className="mt-2">
                                  {showDescription != product.Id
                                    ? product.InfoLines != null &&
                                      product.InfoLines.slice(
                                        0,
                                        isMobile ? 3 : 4
                                      ).map((infoLine, index) => (
                                        <>
                                          <Col
                                            lg={6}
                                            className="product-content d-flex"
                                          >
                                            <img
                                              className="product-content-image mr-1"
                                              src="/assets/images/tick.webp"
                                            />
                                            <ReadMoreReact
                                              text={infoLine.Description}
                                              min={10}
                                              readMoreText={
                                                <a className="text-primary">
                                                  Read More
                                                </a>
                                              }
                                            />
                                          </Col>
                                        </>
                                      ))
                                    : product.InfoLines != null &&
                                      product.InfoLines.map(
                                        (infoLine, index) => (
                                          <>
                                            <Col
                                              lg={6}
                                              className="product-content d-flex"
                                            >
                                              <img
                                                className="product-content-image mr-1"
                                                src="/assets/images/tick.webp"
                                              />
                                              <ReadMoreReact
                                                text={infoLine.Description}
                                                min={10}
                                                readMoreText={
                                                  <a className="text-primary">
                                                    Read More
                                                  </a>
                                                }
                                              />
                                            </Col>
                                          </>
                                        )
                                      )}
                                  {product.InfoLines != null &&
                                    product.InfoLines.length >
                                      (isMobile ? 3 : 4) && (
                                      <Col
                                        lg={6}
                                        onClick={() => {
                                          setShowDescription(
                                            showDescription == product.Id
                                              ? false
                                              : product.Id
                                          );
                                        }}
                                        role="button"
                                        className="product-content"
                                      >
                                        <label>
                                          {showDescription == product.Id
                                            ? "- View Less"
                                            : "+ View More"}
                                        </label>
                                      </Col>
                                    )}
                                </Row>
                                {/* <ul>
                                <li>
                                  {" "}
                                  <i>
                                    {" "}
                                    <img src="/assets/products/tick.webp" />
                                  </i>{" "}
                                  10000Km Oil And Filter change
                                </li>

                                <li>
                                  {" "}
                                  <i>
                                    {" "}
                                    <img src="/assets/products/tick.webp" />
                                  </i>
                                  10W40 Semi-Synthetic Engine Oil{" "}
                                </li>

                                <li>
                                  {" "}
                                  <i>
                                    {" "}
                                    <img src="/assets/products/tick.webp" />
                                  </i>
                                  Genuine Oil Filter
                                </li>
                                <li>
                                  {" "}
                                  <i>
                                    {" "}
                                    <img src="/assets/products/tick.webp" />
                                  </i>
                                  Fluid Top-up
                                </li>
                              </ul>

                              <label>+ View More</label> */}
                              </div>

                              <div className="pl-feture-first dsk-view">
                                <div className="oft-lbs">
                                  {product.Offers && product.Offers?.length ? (
                                    <label
                                      className="pl-offer-label"
                                      title={"Offer Available"}
                                      onClick={() =>
                                        handleshowOffers(product.Offers)
                                      }
                                    >
                                      <img src="/assets/products/party-icon.webp" />
                                      {product.Offers?.length}{" "}
                                      {product.Offers?.length == 1
                                        ? "Offer"
                                        : "Offers"}{" "}
                                      Available
                                    </label>
                                  ) : null}

                                  <label
                                    className="pl--tl-workshop"
                                    style={{
                                      fontSize: "12px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    <img
                                      width={15}
                                      height={13}
                                      style={{ marginBottom: "2px" }}
                                      src="/assets/header/ob-network-new-logo.svg"
                                      alt="Image"
                                    />
                                    {product?.WorkshopCount} Workshops
                                  </label>
                                </div>

                                {/* <i className="fa-solid fa-shop"></i>  */}

                                <label className="chk-label">
                                  Add to Compare
                                  <input
                                    type="checkbox"
                                    onChange={(e) => handleCompare(e, product)}
                                  />
                                  <span className="check-mark"></span>
                                </label>
                              </div>

                              <div className="price-pl-blck dsk-view align-items-start">
                                <div className="price-pl-lf">
                                  <label className="price-tag-pl">
                                    {globalData.carData?.brand &&
                                      product.Cost > 0 && (
                                        <>
                                          <div
                                            className="dst-price-item flex-column"
                                            style={{ alignItems: "baseline" }}
                                          >
                                            <p>Best Price</p>
                                            <div className="d-flex aling-itens-center">
                                              <label className="mr-1">
                                                AED{" "}
                                              </label>

                                              <strong
                                                className={
                                                  discountValue
                                                    ? "offer-applied-ui"
                                                    : ""
                                                }
                                                style={{
                                                  whiteSpace: "pre-wrap",
                                                }}
                                              >
                                                {parseFloat(
                                                  product.Cost
                                                ).toFixed(2)}
                                              </strong>

                                              {/* {discountValue ? (
                                            <strong
                                              className={discountValue ? "" : "px-1"}
                                            >
                                              {" "}
                                              <>
                                                {parseFloat(discountValue || 0).toFixed(
                                                  2
                                                )}
                                              </>
                                            </strong>
                                          ) : null} */}

                                              <span className="ml-1 d-inline ">
                                                <ButtonToolbar>
                                                  <OverlayTrigger
                                                    trigger={["hover", "focus"]}
                                                    placement="right"
                                                    overlay={popoverHoverFocus}
                                                  >
                                                    <Button
                                                      style={{
                                                        padding: "0",
                                                        marginBottom: "5px",
                                                        marginTop: "-2px",
                                                        border: "none",
                                                        background: "none",
                                                        color: "back",
                                                      }}
                                                    >
                                                      {" "}
                                                      <BsInfoCircle color="#000" />
                                                    </Button>
                                                  </OverlayTrigger>
                                                </ButtonToolbar>
                                              </span>
                                            </div>
                                            <div style={{}}>
                                              <div style={{}}>
                                                <span
                                                  style={{
                                                    display: "flex",
                                                    fontWeight: "450",
                                                    color: "black",
                                                    fontSize: "13px",
                                                  }}
                                                >
                                                  Set of 2 : AED{" "}
                                                  <span
                                                    className={
                                                      discountValue
                                                        ? "offer-applied-ui"
                                                        : ""
                                                    }
                                                    style={{
                                                      whiteSpace: "pre-wrap",
                                                      color: "black",
                                                      fontSize: "13px",
                                                    }}
                                                  >
                                                    {" "}
                                                    {parseFloat(
                                                      product.OriginalCost
                                                    ).toFixed(2) * 2}
                                                  </span>{" "}
                                                </span>
                                              </div>
                                              <div style={{}}>
                                                <span
                                                  style={{
                                                    display: "flex",
                                                    fontWeight: "450",
                                                    color: "black",
                                                    fontSize: "13px",
                                                  }}
                                                >
                                                  Set of 4 : AED
                                                  <span
                                                    className={
                                                      discountValue
                                                        ? "offer-applied-ui"
                                                        : ""
                                                    }
                                                    style={{
                                                      whiteSpace: "pre-wrap",
                                                      color: "black",
                                                      fontSize: "13px",
                                                    }}
                                                  >
                                                    {" "}
                                                    {parseFloat(
                                                      product.OriginalCost
                                                    ).toFixed(2) * 4}
                                                  </span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                  </label>
                                </div>
                                <div>
                                  {globalData.carData?.brand &&
                                    product.Cost > 0 && (
                                      // <select
                                      //   className="form-select form-select-sm bg-light rounded pl-1 pr-1"
                                      //   aria-label={`form-select-sm example-${index}`}
                                      //   // Bind select value to state
                                      //   onChange={(e) => handleChange(e, product)
                                      //   } // Call handleChange when select value changes
                                      // >
                                      //   {options.map(option => (
                                      //     <option key={option.value} value={option.value}>{option.label}</option>
                                      //   ))}
                                      // </select>
                                      <Select
                                        className="form-select form-select-sm bg-light rounded pl-1 pr-1"
                                        aria-label={`form-select-sm example-${index}`}
                                        onChange={(selectedOption) =>
                                          handleChange(selectedOption, product)
                                        }
                                        options={options}
                                        // value={selectedValue}
                                        styles={colourStyles}
                                        defaultValue={[options[0]]}
                                      />
                                    )}
                                </div>{" "}
                                <div className="price-pl-rght">
                                  {globalData.carData?.brand &&
                                    product.Cost > 0 && (
                                      <div className="fitting-checkbox">
                                        <label className="chk-label">
                                          Get Fitting at Home
                                          <input
                                            type="checkbox"
                                            onClick={(e) => {
                                              const getFittingAtHome =
                                                sessionStorage.getItem(
                                                  "get-fitting-at-home"
                                                );
                                              let value = JSON.parse(
                                                getFittingAtHome ??
                                                  JSON.stringify([])
                                              );
                                              const data = value.filter(
                                                (item) => item == product.Id
                                              );
                                              if (data.length)
                                                value = value.filter(
                                                  (item) => item != product.Id
                                                );
                                              else value.push(product.Id);
                                              sessionStorage.setItem(
                                                "get-fitting-at-home",
                                                JSON.stringify(value)
                                              );
                                            }}
                                          />
                                          <span className="check-mark"></span>
                                        </label>
                                        <small style={{ fontSize: "11px" }}>
                                          AED 100.00 Extra Charge
                                        </small>
                                      </div>
                                    )}
                                  {globalData.carData != null ? (
                                    products?.filter(
                                      (prod) => prod.Id == product.Id
                                    ).length === 1 &&
                                    cart?.stage == 1 &&
                                    cart?.journeyType === workshopPurchase ? (
                                      <>
                                        <Button
                                          className="workshop-button-one bg-yellow"
                                          onClick={() => handleUnselect()}
                                          disabled={isSubmitting}
                                        >
                                          Remove{" "}
                                          {isSubmitting && (
                                            <Spinner
                                              animation="grow"
                                              role="status"
                                              className="ml-2"
                                              size="sm"
                                            >
                                              <span className="visually-hidden"></span>
                                            </Spinner>
                                          )}
                                        </Button>
                                      </>
                                    ) : (
                                      <>
                                        {cart?.workshop ? (
                                          <>
                                            {products?.filter(
                                              (prod) => prod.Id == product.Id
                                            ).length === 1 ? (
                                              <Button
                                                onClick={() =>
                                                  removeFromCart(product)
                                                }
                                                className="workshop-button-one remove"
                                                disabled={isSubmitting}
                                                // disabled={
                                                //   excludedVariantIds.includes(item.Id) ||
                                                //   checkAdded
                                                // }
                                              >
                                                {/* {checkAdded ? "Added" : "Add to cart"} */}
                                                Remove{" "}
                                                {isSubmitting && (
                                                  <Spinner
                                                    animation="grow"
                                                    role="status"
                                                    className="ml-2"
                                                    size="sm"
                                                  >
                                                    <span className="visually-hidden"></span>
                                                  </Spinner>
                                                )}
                                              </Button>
                                            ) : (
                                              <Button
                                                onClick={() =>
                                                  addToCart(product)
                                                }
                                                className="workshop-button-one glare-animation"
                                                disabled={isSubmitting}
                                                //   disabled={
                                                //     excludedVariantIds.includes(item.Id) ||
                                                //     checkAdded
                                                //   }
                                              >
                                                Add to cart{" "}
                                                {isSubmitting && (
                                                  <Spinner
                                                    animation="grow"
                                                    role="status"
                                                    className="ml-2"
                                                    size="sm"
                                                  >
                                                    <span className="visually-hidden"></span>
                                                  </Spinner>
                                                )}
                                              </Button>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <Button
                                              onClick={() => {
                                                if (showQuoteSelect) {
                                                  setShowQuoteSelect(false);
                                                  localStorage.removeItem(
                                                    "isQuoterequest"
                                                  );
                                                  setCartJourney(
                                                    workshopPurchase
                                                  );
                                                  let tyreItem =
                                                    cart.tyreQuotation;
                                                  tyreItem.isProceed = false;
                                                  tyreItem.width = null;
                                                  tyreItem.height = null;
                                                  tyreItem.rim = null;
                                                  tyreItem.data = null;
                                                  setCartTypeParameter(
                                                    tyreItem
                                                  );
                                                  let item =
                                                    cart.batteryQuotation;
                                                  item.isProceed = false;
                                                  item.data = null;
                                                  item.type = null;
                                                  setCartBatteryParameter(item);
                                                  return;
                                                }

                                                handleWorkshopSelection(
                                                  product
                                                );
                                              }}
                                              className={`workshop-button-one shine-animation-new  item-${index} ${
                                                showQuoteSelect
                                                  ? isMobile
                                                    ? "quote-yellow"
                                                    : "quote-yellow"
                                                  : ""
                                              }`}
                                              style={
                                                product.Cost <= 0
                                                  ? {
                                                      padding: showQuoteSelect
                                                        ? "18px 50px"
                                                        : "18px 35px",
                                                      marginTop: "5px",
                                                      // marginLeft: isMobile
                                                      //   ? "94px"
                                                      //   : "0px",
                                                    }
                                                  : {}
                                              }
                                              disabled={isSubmitting}
                                            >
                                              {/* {item.Cost > 0 ? "Select" : "Request Quote"} */}
                                              {product.Cost > 0
                                                ? "Select"
                                                : product.Cost < 0 &&
                                                  !showQuoteSelect &&
                                                  !isQuoterequest
                                                ? "Request Quote"
                                                : "Remove"}
                                              {/* {item.Id == 55 ? "Select" : "Request Quote"} */}{" "}
                                              {isSubmitting && (
                                                <Spinner
                                                  animation="grow"
                                                  role="status"
                                                  className="ml-2"
                                                  size="sm"
                                                >
                                                  <span className="visually-hidden"></span>
                                                </Spinner>
                                              )}
                                            </Button>
                                          </>
                                        )}
                                      </>
                                    )
                                  ) : (
                                    <ChooseCar
                                      // CHoose Car to View Price
                                      globalData={globalData}
                                      style={"workshop-button-one"}
                                      textTrue={true}
                                      apiData={apiData}
                                      getModel={getModel}
                                      getCarBrandModal={getCarBrandModal}
                                      text="Choose Car to View Price"
                                      // mobileCartView
                                      showMobileBtn={isMobile ? true : false}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <label className="chk-label mob-compare ml-4">
                            Compare
                            <input
                              type="checkbox"
                              onChange={(e) => handleCompare(e, product)}
                            />
                            <span className="check-mark"></span>
                          </label>
                          <div className="mobile-pl-bar-action">
                            <div className="mobile-bottom-sr-select">
                              <div className="pl-feture-first">
                                <div className="price-pl-lf">
                                  <label className="price-tag-pl">
                                    <span>Best Price</span>
                                    <div className="d-flex">
                                      <strong>AED </strong>{" "}
                                      <strong
                                        className={
                                          discountValue
                                            ? "offer-applied-ui"
                                            : ""
                                        }
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          marginLeft: "3px",
                                        }}
                                      >
                                        {parseFloat(product.Cost).toFixed(2)}
                                      </strong>
                                      {/* {discountValue ? (
                                            <strong
                                              className={discountValue ? "" : "px-1"}
                                            >
                                              {" "}
                                              <>
                                                {parseFloat(discountValue || 0).toFixed(
                                                  2
                                                )}
                                              </>
                                            </strong>
                                          ) : null} */}
                                      <span className="ml-1 d-inline ">
                                        <OverlayTrigger
                                          trigger={["hover", "focus"]}
                                          placement="top"
                                          overlay={
                                            <Popover id="popover-trigger-hover-focus light-blue-new">
                                              <Popover.Content>
                                                <h6 className="">
                                                  FULLY FITTED PRICE PER TYRE
                                                </h6>
                                                <span className="">
                                                  There are NO EXTRAS to pay on
                                                  the day of your visit-in
                                                  relation to the tyre fitting.
                                                </span>
                                                <br />
                                                <span className="">
                                                  There are following is
                                                  included in the price.
                                                </span>
                                                <ul>
                                                  <li>. Vat</li>
                                                  <li>
                                                    . (bead lock wheel etc.
                                                    exicuted)
                                                  </li>
                                                  <li>. Balancing</li>
                                                  <li>
                                                    . New rubber valve (standard
                                                    valve only)
                                                  </li>
                                                  <li>
                                                    . Delever to installer
                                                  </li>
                                                  <li>
                                                    . Disposal of old tyres
                                                  </li>
                                                </ul>
                                              </Popover.Content>
                                            </Popover>
                                          }
                                        >
                                          <Button
                                            style={{
                                              padding: "0",
                                              marginBottom: "5px",

                                              border: "none",
                                              background: "none",
                                              color: "black",
                                            }}
                                          >
                                            {" "}
                                            <BsInfoCircle />
                                          </Button>
                                        </OverlayTrigger>
                                      </span>
                                    </div>
                                    {/* <div style={{fontSize:"11px"}}>
                                           <strong>Set of 2 :</strong>
                                           <strong>AED</strong>
                                          {" "}
                                          <strong
                                            className={
                                              discountValue ? "offer-applied-ui" : ""
                                            }
                                            style={{ whiteSpace: "pre-wrap" }}
                                          >

                                            {parseFloat(product.Cost).toFixed(2) *2/selectedValue} 

                                          </strong>
                                          </div>
                                          <div style={{fontSize:"11px"}}>
                                          <strong>Set of 4 :</strong>
                                           <strong>AED</strong>
                                          {" "}
                                          <strong
                                            className={
                                              discountValue ? "offer-applied-ui" : ""
                                            }
                                            style={{ whiteSpace: "pre-wrap" }}
                                          >

                                            {parseFloat(product.Cost).toFixed(2) *4/selectedValue} 

                                          </strong>
                                          </div> */}
                                  </label>
                                </div>

                                <div className="oft-lbs">
                                  <label className="pl-offer-label pl-4">
                                    <img src="/assets/products/party-icon.webp" />
                                    3 Offer Available
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="mobile-bottom-sr-select">
                              <div className="d-flex justify-content-between w-100">
                                {globalData?.carData?.brand && (
                                  <div style={{ fontSize: 14 }}>
                                    Order Now, Install{"  "}
                                    <label style={{ color: "#0451be" }}>
                                      Tomorrow
                                    </label>
                                  </div>
                                )}
                                <label
                                  className="pl--tl-workshop"
                                  style={{ marginBottom: "0px" }}
                                >
                                  {/* <i className="fa-solid fa-shop"></i> */}
                                  <img
                                    width={15}
                                    height={13}
                                    style={{ marginBottom: "2px" }}
                                    src="/assets/header/ob-network-new-logo.svg"
                                    alt="Image"
                                  />
                                  {product?.WorkshopCount} Workshops
                                </label>
                              </div>
                              <div className="d-flex justify-content-between w-100 align-items-center">
                                <div className="fitting-checkbox">
                                  <label className="chk-label">
                                    Get Fitting at Home
                                    <input type="checkbox" />
                                    <span className="check-mark"></span>
                                  </label>
                                  <small style={{ fontSize: "11px" }}>
                                    AED 100.00 Extra Charge
                                  </small>
                                </div>

                                {globalData.carData != null ? (
                                  products?.filter(
                                    (prod) => prod.Id == product.Id
                                  ).length === 1 &&
                                  cart?.stage == 1 &&
                                  cart?.journeyType === workshopPurchase ? (
                                    <>
                                      <Button
                                        className="workshop-button-one bg-yellow"
                                        onClick={() => handleUnselect()}
                                        disabled={isSubmitting}
                                      >
                                        Remove{" "}
                                        {isSubmitting && (
                                          <Spinner
                                            animation="grow"
                                            role="status"
                                            className="ml-2"
                                            size="sm"
                                          >
                                            <span className="visually-hidden"></span>
                                          </Spinner>
                                        )}
                                      </Button>
                                    </>
                                  ) : (
                                    <>
                                      {cart?.workshop ? (
                                        <>
                                          {products?.filter(
                                            (prod) => prod.Id == product.Id
                                          ).length === 1 ? (
                                            <Button
                                              onClick={() =>
                                                removeFromCart(product)
                                              }
                                              className="workshop-button-one remove"
                                              disabled={isSubmitting}
                                              // disabled={
                                              //   excludedVariantIds.includes(item.Id) ||
                                              //   checkAdded
                                              // }
                                            >
                                              {/* {checkAdded ? "Added" : "Add to cart"} */}
                                              Remove{" "}
                                              {isSubmitting && (
                                                <Spinner
                                                  animation="grow"
                                                  role="status"
                                                  className="ml-2"
                                                  size="sm"
                                                >
                                                  <span className="visually-hidden"></span>
                                                </Spinner>
                                              )}
                                            </Button>
                                          ) : (
                                            <Button
                                              onClick={() => addToCart(product)}
                                              className="workshop-button-one glare-animation"
                                              disabled={isSubmitting}
                                              //   disabled={
                                              //     excludedVariantIds.includes(item.Id) ||
                                              //     checkAdded
                                              //   }
                                            >
                                              Add to cart{" "}
                                              {isSubmitting && (
                                                <Spinner
                                                  animation="grow"
                                                  role="status"
                                                  className="ml-2"
                                                  size="sm"
                                                >
                                                  <span className="visually-hidden"></span>
                                                </Spinner>
                                              )}
                                            </Button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <Button
                                            onClick={() => {
                                              if (showQuoteSelect) {
                                                setShowQuoteSelect(false);
                                                localStorage.removeItem(
                                                  "isQuoterequest"
                                                );
                                                setCartJourney(
                                                  workshopPurchase
                                                );
                                                let tyreItem =
                                                  cart.tyreQuotation;
                                                tyreItem.isProceed = false;
                                                tyreItem.width = null;
                                                tyreItem.height = null;
                                                tyreItem.rim = null;
                                                tyreItem.data = null;
                                                setCartTypeParameter(tyreItem);
                                                let item =
                                                  cart.batteryQuotation;
                                                item.isProceed = false;
                                                item.data = null;
                                                item.type = null;
                                                setCartBatteryParameter(item);
                                                return;
                                              }

                                              handleWorkshopSelection(product);
                                            }}
                                            className={`workshop-button-one shine-animation-new item-${index} ${
                                              showQuoteSelect
                                                ? isMobile
                                                  ? "quote-yellow"
                                                  : "quote-yellow"
                                                : ""
                                            }`}
                                            style={
                                              product.Cost <= 0
                                                ? {
                                                    padding: showQuoteSelect
                                                      ? "18px 50px"
                                                      : "18px 35px",
                                                    marginTop: "5px",
                                                    // marginLeft: isMobile
                                                    //   ? "94px"
                                                    //   : "0px",
                                                  }
                                                : {}
                                            }
                                            disabled={isSubmitting}
                                          >
                                            {/* {item.Cost > 0 ? "Select" : "Request Quote"} */}
                                            {product.Cost > 0
                                              ? "Select"
                                              : product.Cost < 0 &&
                                                !showQuoteSelect &&
                                                !isQuoterequest
                                              ? "Request Quote"
                                              : "Remove"}
                                            {/* {item.Id == 55 ? "Select" : "Request Quote"} */}{" "}
                                            {isSubmitting && (
                                              <Spinner
                                                animation="grow"
                                                role="status"
                                                className="ml-2"
                                                size="sm"
                                              >
                                                <span className="visually-hidden"></span>
                                              </Spinner>
                                            )}
                                          </Button>
                                        </>
                                      )}
                                    </>
                                  )
                                ) : (
                                  <ChooseCar
                                    // CHoose Car to View Price
                                    globalData={globalData}
                                    style={"workshop-button-one"}
                                    textTrue={true}
                                    apiData={apiData}
                                    getModel={getModel}
                                    getCarBrandModal={getCarBrandModal}
                                    text="Choose Car to View Price"
                                    // mobileCartView
                                    showMobileBtn={isMobile ? true : false}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tabby-bar-pr-list mt-2 justify-content-end mt-md-n4">
                          <img src="/assets/images/tabby.webp" />
                          <p>
                            Split in 4 interest-free payments of{" "}
                            <strong>AED 212.75</strong> / month{" "}
                            <span onClick={() => setTabbyModel(true)}>
                              <MdInfoOutline size={16} />
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="no-job-list p-5">
                  <h3>
                    No Tyres found for{" "}
                    {!tyreSize
                      ? `Car Model: ${carData?.brand} - ${carData?.modal}`
                      : `size : ${tyreSize?.width}/${tyreSize?.height}/R${tyreSize?.rim}`}
                    .
                  </h3>
                  <button
                    className="srv-act-action"
                    onClick={() => {
                      if (showQuoteSelectTyre) {
                        setShowQuoteSelectTyre(false);
                        // localStorage.removeItem(
                        //   "isQuoterequest"
                        // );
                        setCartJourney(workshopPurchase);
                        localStorage.removeItem("isQuoterequest");
                        localStorage.removeItem("selected-service-title");
                        let tyreItem = cart.tyreQuotation;
                        tyreItem.isProceed = false;
                        tyreItem.width = null;
                        tyreItem.height = null;
                        tyreItem.rim = null;
                        tyreItem.data = null;
                        setCartTypeParameter(tyreItem);
                        return;
                      }

                      setShowQuoteSelectTyre(true);
                      setCartJourney(tyreQuotation);
                      localStorage.setItem("isQuoterequest", true);
                      localStorage.setItem(
                        "selected-service-title",
                        "New Tyres"
                      );
                      if (isMobile) {
                        setShowMobileIstand(true);
                      }
                      setLayer(true);
                    }}
                  >
                    {showQuoteSelectTyre ? "Remove" : "Request Quote"}
                  </button>
                </div>
              )}
              {tyreProduct.length > 0 && (
                <div className="d-flex flex-column align-items-center mb-5">
                  <h4>Unable to find the Tyres you were looking for?</h4>
                  <button
                    style={{
                      fontSize: "13px",
                      lineHeight: "13px",
                      // zIndex: 9,
                      // bottom: "-51px",
                      // position: "absolute",
                      // left: "37%",
                    }}
                    className={`srv-act-action shine-animation-new ${
                      showQuoteSelectTyre ? "bg-yellow" : ""
                    }`}
                    onClick={() => {
                      if (showQuoteSelectTyre) {
                        setShowQuoteSelectTyre(false);
                        // localStorage.removeItem(
                        //   "isQuoterequest"
                        // );
                        setCartJourney(workshopPurchase);
                        localStorage.removeItem("isQuoterequest");
                        localStorage.removeItem("selected-service-title");
                        let tyreItem = cart.tyreQuotation;
                        tyreItem.isProceed = false;
                        tyreItem.width = null;
                        tyreItem.height = null;
                        tyreItem.rim = null;
                        tyreItem.data = null;
                        setCartTypeParameter(tyreItem);
                        return;
                      }

                      setShowQuoteSelectTyre(true);
                      setCartJourney(tyreQuotation);
                      localStorage.setItem("isQuoterequest", true);
                      localStorage.setItem(
                        "selected-service-title",
                        "New Tyres"
                      );
                      if (isMobile) {
                        setShowMobileIstand(true);
                      }
                      setLayer(true);
                    }}
                  >
                    {showQuoteSelectTyre ? "Remove" : "Request Quote"}
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="tyre-fet-usr d-none">
            <h3>Why Buy Your Car Tyres With Open Bonnet?</h3>
            <ul>
              <li>
                <img src="/assets/products/thumb.svg" />
                <span>Best Prices</span>
              </li>
              <li>
                <img src="/assets/products/thumb.svg" />
                <span>Widest Outlet Network</span>
              </li>
              <li>
                <img src="/assets/products/thumb.svg" />
                <span>Split In Installments</span>
              </li>
              <li>
                <img src="/assets/products/thumb.svg" />
                <span> No Hidden Charges</span>
              </li>
              <li>
                <img src="/assets/products/thumb.svg" />
                <span> Free 10K Rotation</span>
              </li>
            </ul>
          </div>
        </>
      )}
      {changeOfferModalShow ? (
        <Offers
          setChangeOfferModalShow={setChangeOfferModalShow}
          changeOfferModalShow={changeOfferModalShow}
          offers={CurrentOffers}
          addOffers={addOffers}
          cart={cart}
          item={selectedTyreProduct}
        />
      ) : (
        ""
      )}
      <ChooseCarMobile show={carPopupMobile} setShow={setCarPopupMobile} />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    globalData: state.globalData,
    apiData: state.apiData,
    loginData: state.loginData,
    profile: state.profile,
    cart: state.cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddToCompare: (data) => {
      dispatch(AddToCompare(data));
    },
    RemoveFromCompare: (data) => {
      dispatch(RemoveFromCompare(data));
    },
    toggleChooseCar: (data) => {
      dispatch(toggleChooseCar(data));
    },
    getModel: (id) => {
      dispatch(getModel(id));
    },
    getCarBrandModal: (
      brand,
      modal,
      logoBrand,
      logoModal,
      brandId,
      modelId,
      slug = null
    ) => {
      dispatch(
        getCarBrandModal(
          brand,
          modal,
          logoBrand,
          logoModal,
          brandId,
          modelId,
          slug
        )
      );
    },
    setCartJourney: (data) => {
      dispatch(setCartJourney(data));
    },
    getNewTyresVariants: (width, height, rim) => {
      dispatch(getNewTyresVariants(width, height, rim));
    },
    getNewTyresVariantsByModel: (carModeId) => {
      dispatch(getNewTyresVariantsByModel(carModeId));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    setCartProducts: (products) => {
      dispatch(setCartProducts(products));
    },
    setCartJobItems: (products) => {
      dispatch(setCartJobItems(products));
    },
    getWorkshopFilterMapTyre: (productId, lat, lang) => {
      dispatch(getWorkshopFilterMapTyre(productId, lat, lang));
    },
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setCartWorkshop: (data) => {
      dispatch(setCartWorkshop(data));
    },
    setCartTypeParameter: (data) => {
      dispatch(setCartTypeParameter(data));
    },
    setCarPopup: (data) => {
      dispatch(setCarPopup(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewTyres);
